import { render, staticRenderFns } from "./vipuserManage.vue?vue&type=template&id=bc68433e&"
import script from "./vipuserManage.vue?vue&type=script&lang=js&"
export * from "./vipuserManage.vue?vue&type=script&lang=js&"
import style0 from "./vipuserManage.vue?vue&type=style&index=0&id=bc68433e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports